// extracted by mini-css-extract-plugin
module.exports = {"ReactCodeInput":"ReactCodeInput___2GuTz"};